enum StripePricingIdsProd {
  MONTHLY = "price_1Lhb3pJxfuw0gUiiTs1POL06",
  ANNUALLY = "price_1Lhb4OJxfuw0gUiiwjg4Jwxf",
  QUARTERLY = "price_1IhvELJxfuw0gUiigpFQqfou",
  MULTI_SEAT_MONTHLY = "price_1OoQrtJxfuw0gUii7YJ5rFtk",
  MULTI_SEAT_ANNUALLY = "price_1OyAi8Jxfuw0gUiiSTRjjnTZ",
  MULTI_SEAT_MONTHLY_NOK = "price_1UL3VNJxfuw0gUiij4PdLuYi",
  MULTI_SEAT_ANNUALLY_NOK = "price_1UL3WMJxfuw0gUiifcfoKxGu",
}
export default StripePricingIdsProd;
